<template>
  <div>

    <div class="child-container">
      <div class="empty">
        <button class="button-yellow" @click="$emit('create')">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
            <path fill="#EA7801" stroke="#EA7801" stroke-width=".3" d="M8.578 2.1h-.15v6.328H2.1v1.144h6.328V15.9h1.144V9.572H15.9V8.428H9.572V2.1h-.994Z"/>
          </svg>
          Create new activation
        </button>
        <p class="subtitle">{{ activations.length }} activations</p>
      </div>
    </div>

    <div class="child-container" v-if="activations.length > 0">
      <div class="header pointer" @click="$emit('toggleExpanded', !expanded)">
        <div class="item">
          <div class="icon-container">
            <!-- ToDo: Move to icon-component? -->
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <mask id="a" width="20" height="19" x="2" y="2.188" fill="#000" maskUnits="userSpaceOnUse">
                <path fill="#fff" d="M2 2.188h20v19H2z"/>
                <path d="m14 3.188-.283.282-1.283 1.283L14 6.32l1.566-1.566L14 3.188Zm-5 .965a.4.4 0 0 0-.4.4v2a.4.4 0 0 0 .4.4h.4c.478 0 .582.144.684.374.103.23.116.574.116.826 0 .327-.04.67-.095 1a3.129 3.129 0 0 0-1.002-.2c-.353-.002-.704.097-.955.348a1.102 1.102 0 0 0-.235.37l-.007-.002L3.51 20.812l11.541-3.951-.002-.007c.148-.056.287-.133.403-.249.3-.299.38-.73.336-1.161a3.426 3.426 0 0 0-.22-.857c.316-.02.652-.034 1.032-.034.57 0 1.11.07 1.46.19.175.062.299.136.359.193.06.057.063.073.063.117v.3a.4.4 0 0 0 .4.4H20.6a.401.401 0 0 0 .4-.412l-.012-.498c.007-.908-.564-1.613-1.27-2.045a4.569 4.569 0 0 0-2.327-.645c-1.265 0-2.206.328-2.836.653a11.38 11.38 0 0 0-.656-.811 9.72 9.72 0 0 1 .428-.126c.281-.076.548-.14.755-.185.207-.047.322-.067.426-.096.323-.09.763-.2 1.158-.464.395-.264.734-.739.734-1.37 0-.174-.084-.27-.14-.4h.14c.855 0 1.6-.691 1.6-1.6v-.55s.003-.055.04-.116c.038-.062.068-.135.36-.135h.4a.4.4 0 0 0 .4-.4V4.954a.4.4 0 0 0-.4-.4h-.649c-1.063 0-1.72.491-2.07.96-.261.346-.341.775-.403 1.143-.027.162-.022.179-.034.296H16.6c-.689 0-1.229.25-1.557.644-.329.394-.443.89-.443 1.356v.543c-.656.216-1.406.567-2.052 1.178a11.18 11.18 0 0 0-1.13-.854c.41-.723.782-1.699.782-2.867 0-.689-.228-1.384-.706-1.917-.478-.533-1.21-.883-2.124-.883H9Zm5 .166.434.434-.434.435-.434-.435L14 4.32Zm-8.4.469-.283.282-1.283 1.283L5.6 7.92l1.566-1.566L5.6 4.788Zm3.8.17c.698.009 1.174.251 1.498.612.33.368.502.872.502 1.383 0 .833-.243 1.512-.525 2.098.045-.307.125-.578.125-.898 0-.252.013-.707-.184-1.151-.198-.445-.694-.849-1.416-.849V4.96Zm9.75.396h.25v.8c-.508 0-.878.25-1.04.515-.163.264-.16.534-.16.534v.55c0 .49-.355.8-.8.8h-.8a.4.4 0 0 0-.29.675l.01.012a1.766 1.766 0 0 1 .147.191.832.832 0 0 1 .133.322c0 .383-.136.543-.378.705-.243.162-.602.268-.93.36a22.65 22.65 0 0 0-.385.085c-.214.048-.49.113-.79.194a7.33 7.33 0 0 0-1.337.535c.67-.833 1.59-1.287 2.328-1.494a.4.4 0 0 0 .292-.385v-.8c0-.333.085-.638.257-.844.171-.206.432-.356.943-.356h.4a.4.4 0 0 0 .4-.379s.014-.266.067-.585c.053-.319.173-.69.252-.796.25-.332.593-.64 1.432-.639ZM5.6 5.919l.434.434-.434.435-.434-.435.434-.434Zm14 3.434-1 1 1 1 1-1-1-1Zm-15.6.4-1 1 1 1 1-1-1-1Zm5.097 0c.21.002.5.078.832.213-.115.436-.225.758-.259.861a.4.4 0 0 0 .642.428 3.54 3.54 0 0 0 .333-.344c.096-.109.207-.246.324-.403.34.214.696.473 1.051.77-.051.07-.106.137-.154.213l-.802 1.246a.4.4 0 0 0 .563.545l1.203-.83c.071-.05.163-.1.268-.15.286.31.548.62.776.927a3.896 3.896 0 0 0-.247.204l-.908.898a.4.4 0 0 0 .425.657s.525-.2 1.59-.328c.146.335.235.635.259.866.03.287-.028.435-.106.514a.352.352 0 0 1-.13.076l-.041.014a.895.895 0 0 1-.28.02c-.25-.014-.593-.108-.982-.284-.778-.354-1.734-1.029-2.636-1.93-.902-.903-1.577-1.86-1.93-2.637-.177-.389-.27-.733-.286-.983a.882.882 0 0 1 .023-.29c.002-.008.006-.014.009-.021a.352.352 0 0 1 .08-.139c.065-.065.173-.114.383-.113Zm-1.024 1.672c.028.068.054.136.086.205.408.9 1.134 1.911 2.093 2.87.96.96 1.971 1.686 2.87 2.095l.108.044-8.34 2.855 3.183-8.069Zm9.318 1.528c.61 0 1.357.188 1.909.527.552.338.893.778.888 1.355l.003.118h-.954c-.03-.227-.113-.45-.268-.598a1.749 1.749 0 0 0-.647-.367c-.49-.17-1.092-.235-1.722-.235-1.03 0-1.734.106-2.345.206.092-.088 1.079-1.006 3.136-1.006Zm-.591 4.634-.283.283-1.283 1.283L16.8 20.72l1.566-1.566-1.566-1.566Zm0 1.132.434.434-.434.434-.434-.434.434-.434Z"/>
              </mask>
              <path fill="#333" d="m14 3.188-.283.282-1.283 1.283L14 6.32l1.566-1.566L14 3.188Zm-5 .965a.4.4 0 0 0-.4.4v2a.4.4 0 0 0 .4.4h.4c.478 0 .582.144.684.374.103.23.116.574.116.826 0 .327-.04.67-.095 1a3.129 3.129 0 0 0-1.002-.2c-.353-.002-.704.097-.955.348a1.102 1.102 0 0 0-.235.37l-.007-.002L3.51 20.812l11.541-3.951-.002-.007c.148-.056.287-.133.403-.249.3-.299.38-.73.336-1.161a3.426 3.426 0 0 0-.22-.857c.316-.02.652-.034 1.032-.034.57 0 1.11.07 1.46.19.175.062.299.136.359.193.06.057.063.073.063.117v.3a.4.4 0 0 0 .4.4H20.6a.401.401 0 0 0 .4-.412l-.012-.498c.007-.908-.564-1.613-1.27-2.045a4.569 4.569 0 0 0-2.327-.645c-1.265 0-2.206.328-2.836.653a11.38 11.38 0 0 0-.656-.811 9.72 9.72 0 0 1 .428-.126c.281-.076.548-.14.755-.185.207-.047.322-.067.426-.096.323-.09.763-.2 1.158-.464.395-.264.734-.739.734-1.37 0-.174-.084-.27-.14-.4h.14c.855 0 1.6-.691 1.6-1.6v-.55s.003-.055.04-.116c.038-.062.068-.135.36-.135h.4a.4.4 0 0 0 .4-.4V4.954a.4.4 0 0 0-.4-.4h-.649c-1.063 0-1.72.491-2.07.96-.261.346-.341.775-.403 1.143-.027.162-.022.179-.034.296H16.6c-.689 0-1.229.25-1.557.644-.329.394-.443.89-.443 1.356v.543c-.656.216-1.406.567-2.052 1.178a11.18 11.18 0 0 0-1.13-.854c.41-.723.782-1.699.782-2.867 0-.689-.228-1.384-.706-1.917-.478-.533-1.21-.883-2.124-.883H9Zm5 .166.434.434-.434.435-.434-.435L14 4.32Zm-8.4.469-.283.282-1.283 1.283L5.6 7.92l1.566-1.566L5.6 4.788Zm3.8.17c.698.009 1.174.251 1.498.612.33.368.502.872.502 1.383 0 .833-.243 1.512-.525 2.098.045-.307.125-.578.125-.898 0-.252.013-.707-.184-1.151-.198-.445-.694-.849-1.416-.849V4.96Zm9.75.396h.25v.8c-.508 0-.878.25-1.04.515-.163.264-.16.534-.16.534v.55c0 .49-.355.8-.8.8h-.8a.4.4 0 0 0-.29.675l.01.012a1.766 1.766 0 0 1 .147.191.832.832 0 0 1 .133.322c0 .383-.136.543-.378.705-.243.162-.602.268-.93.36a22.65 22.65 0 0 0-.385.085c-.214.048-.49.113-.79.194a7.33 7.33 0 0 0-1.337.535c.67-.833 1.59-1.287 2.328-1.494a.4.4 0 0 0 .292-.385v-.8c0-.333.085-.638.257-.844.171-.206.432-.356.943-.356h.4a.4.4 0 0 0 .4-.379s.014-.266.067-.585c.053-.319.173-.69.252-.796.25-.332.593-.64 1.432-.639ZM5.6 5.919l.434.434-.434.435-.434-.435.434-.434Zm14 3.434-1 1 1 1 1-1-1-1Zm-15.6.4-1 1 1 1 1-1-1-1Zm5.097 0c.21.002.5.078.832.213-.115.436-.225.758-.259.861a.4.4 0 0 0 .642.428 3.54 3.54 0 0 0 .333-.344c.096-.109.207-.246.324-.403.34.214.696.473 1.051.77-.051.07-.106.137-.154.213l-.802 1.246a.4.4 0 0 0 .563.545l1.203-.83c.071-.05.163-.1.268-.15.286.31.548.62.776.927a3.896 3.896 0 0 0-.247.204l-.908.898a.4.4 0 0 0 .425.657s.525-.2 1.59-.328c.146.335.235.635.259.866.03.287-.028.435-.106.514a.352.352 0 0 1-.13.076l-.041.014a.895.895 0 0 1-.28.02c-.25-.014-.593-.108-.982-.284-.778-.354-1.734-1.029-2.636-1.93-.902-.903-1.577-1.86-1.93-2.637-.177-.389-.27-.733-.286-.983a.882.882 0 0 1 .023-.29c.002-.008.006-.014.009-.021a.352.352 0 0 1 .08-.139c.065-.065.173-.114.383-.113Zm-1.024 1.672c.028.068.054.136.086.205.408.9 1.134 1.911 2.093 2.87.96.96 1.971 1.686 2.87 2.095l.108.044-8.34 2.855 3.183-8.069Zm9.318 1.528c.61 0 1.357.188 1.909.527.552.338.893.778.888 1.355l.003.118h-.954c-.03-.227-.113-.45-.268-.598a1.749 1.749 0 0 0-.647-.367c-.49-.17-1.092-.235-1.722-.235-1.03 0-1.734.106-2.345.206.092-.088 1.079-1.006 3.136-1.006Zm-.591 4.634-.283.283-1.283 1.283L16.8 20.72l1.566-1.566-1.566-1.566Zm0 1.132.434.434-.434.434-.434-.434.434-.434Z"/>
              <path stroke="#333" stroke-width=".2" d="m14 3.188-.283.282-1.283 1.283L14 6.32l1.566-1.566L14 3.188Zm-5 .965a.4.4 0 0 0-.4.4v2a.4.4 0 0 0 .4.4h.4c.478 0 .582.144.684.374.103.23.116.574.116.826 0 .327-.04.67-.095 1a3.129 3.129 0 0 0-1.002-.2c-.353-.002-.704.097-.955.348a1.102 1.102 0 0 0-.235.37l-.007-.002L3.51 20.812l11.541-3.951-.002-.007c.148-.056.287-.133.403-.249.3-.299.38-.73.336-1.161a3.426 3.426 0 0 0-.22-.857c.316-.02.652-.034 1.032-.034.57 0 1.11.07 1.46.19.175.062.299.136.359.193.06.057.063.073.063.117v.3a.4.4 0 0 0 .4.4H20.6a.401.401 0 0 0 .4-.412l-.012-.498c.007-.908-.564-1.613-1.27-2.045a4.569 4.569 0 0 0-2.327-.645c-1.265 0-2.206.328-2.836.653a11.38 11.38 0 0 0-.656-.811 9.72 9.72 0 0 1 .428-.126c.281-.076.548-.14.755-.185.207-.047.322-.067.426-.096.323-.09.763-.2 1.158-.464.395-.264.734-.739.734-1.37 0-.174-.084-.27-.14-.4h.14c.855 0 1.6-.691 1.6-1.6v-.55s.003-.055.04-.116c.038-.062.068-.135.36-.135h.4a.4.4 0 0 0 .4-.4V4.954a.4.4 0 0 0-.4-.4h-.649c-1.063 0-1.72.491-2.07.96-.261.346-.341.775-.403 1.143-.027.162-.022.179-.034.296H16.6c-.689 0-1.229.25-1.557.644-.329.394-.443.89-.443 1.356v.543c-.656.216-1.406.567-2.052 1.178a11.18 11.18 0 0 0-1.13-.854c.41-.723.782-1.699.782-2.867 0-.689-.228-1.384-.706-1.917-.478-.533-1.21-.883-2.124-.883H9Zm5 .166.434.434-.434.435-.434-.435L14 4.32Zm-8.4.469-.283.282-1.283 1.283L5.6 7.92l1.566-1.566L5.6 4.788Zm3.8.17c.698.009 1.174.251 1.498.612.33.368.502.872.502 1.383 0 .833-.243 1.512-.525 2.098.045-.307.125-.578.125-.898 0-.252.013-.707-.184-1.151-.198-.445-.694-.849-1.416-.849V4.96Zm9.75.396h.25v.8c-.508 0-.878.25-1.04.515-.163.264-.16.534-.16.534v.55c0 .49-.355.8-.8.8h-.8a.4.4 0 0 0-.29.675l.01.012a1.766 1.766 0 0 1 .147.191.832.832 0 0 1 .133.322c0 .383-.136.543-.378.705-.243.162-.602.268-.93.36a22.65 22.65 0 0 0-.385.085c-.214.048-.49.113-.79.194a7.33 7.33 0 0 0-1.337.535c.67-.833 1.59-1.287 2.328-1.494a.4.4 0 0 0 .292-.385v-.8c0-.333.085-.638.257-.844.171-.206.432-.356.943-.356h.4a.4.4 0 0 0 .4-.379s.014-.266.067-.585c.053-.319.173-.69.252-.796.25-.332.593-.64 1.432-.639ZM5.6 5.919l.434.434-.434.435-.434-.435.434-.434Zm14 3.434-1 1 1 1 1-1-1-1Zm-15.6.4-1 1 1 1 1-1-1-1Zm5.097 0c.21.002.5.078.832.213-.115.436-.225.758-.259.861a.4.4 0 0 0 .642.428 3.54 3.54 0 0 0 .333-.344c.096-.109.207-.246.324-.403.34.214.696.473 1.051.77-.051.07-.106.137-.154.213l-.802 1.246a.4.4 0 0 0 .563.545l1.203-.83c.071-.05.163-.1.268-.15.286.31.548.62.776.927a3.896 3.896 0 0 0-.247.204l-.908.898a.4.4 0 0 0 .425.657s.525-.2 1.59-.328c.146.335.235.635.259.866.03.287-.028.435-.106.514a.352.352 0 0 1-.13.076l-.041.014a.895.895 0 0 1-.28.02c-.25-.014-.593-.108-.982-.284-.778-.354-1.734-1.029-2.636-1.93-.902-.903-1.577-1.86-1.93-2.637-.177-.389-.27-.733-.286-.983a.882.882 0 0 1 .023-.29c.002-.008.006-.014.009-.021a.352.352 0 0 1 .08-.139c.065-.065.173-.114.383-.113Zm-1.024 1.672c.028.068.054.136.086.205.408.9 1.134 1.911 2.093 2.87.96.96 1.971 1.686 2.87 2.095l.108.044-8.34 2.855 3.183-8.069Zm9.318 1.528c.61 0 1.357.188 1.909.527.552.338.893.778.888 1.355l.003.118h-.954c-.03-.227-.113-.45-.268-.598a1.749 1.749 0 0 0-.647-.367c-.49-.17-1.092-.235-1.722-.235-1.03 0-1.734.106-2.345.206.092-.088 1.079-1.006 3.136-1.006Zm-.591 4.634-.283.283-1.283 1.283L16.8 20.72l1.566-1.566-1.566-1.566Zm0 1.132.434.434-.434.434-.434-.434.434-.434Z" mask="url(#a)"/>
            </svg>
          </div>
          <div class="details">
            <p class="heading">Activations</p>
            <p class="subtitle">{{ activations.length }} activations</p>
          </div>
        </div>

        <button class="expand-button" :class="{ expanded: this.expanded }" >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" viewBox="0 0 16 17">
            <path fill="#333" d="M5.12 2.1v13.44l7.04-6.72L5.12 2.1Z"/>
          </svg>
        </button>
      </div>

      <transition name="fade-shrink">
        <div v-if="expanded" class="activations" style="{ 'max-height': contentHeight + 'px' }">
          <div v-for="activation in updatedActivations" :key="activation.id" class="item activation">
            <div class="item-container" @click="handleClickActivation(activation)">
              <div class="image-container">
                <img v-if="activation.media && activation.media.length && activation.media[0].url" :src="activation?.media[0].url" :alt="activation.name" />
                <img v-else-if="activation.image" :src="activation.image" :alt="activation.name" />
              </div>
              <div class="details">
                <div class="header">
                  <p class="heading">{{ activation.name || activation.first_header }}</p>
                  <span class="chip" :class="chipStateClass(activation.document_state || activation.created_at)"> {{ activation.document_state || activation.created_at }} </span>
                </div>

                <span v-html="stateInformation(activation)"></span>
              </div>
            </div>
            <DropDown :list-items="getListItems(activation)" class="more" @selected="$event(activation)"/>
          </div>
        </div>
      </transition>
    </div>

    <ActivationPublish
      :activation="activationToPublish"
      :show="!!activationToPublish"
      @published="setAsPublished"
      @close="activationToPublish = null"
    />
  </div>
</template>

<script>
import PartnerMixin from "@/mixins/PartnerMixin.vue";
import DateTimeConverterMixin from "@/mixins/DateTimeConverterMixin.vue";
import DropDown from "@/stories/components/DropDown/DropDown.vue";
import SvgMixin from "@/mixins/SvgMixin.vue";
import ActivationPublish from "@/stories/components/ActivationPublish/ActivationPublish.vue";
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: 'ActivationsList',
  components: {ActivationPublish, DropDown},
  mixins: [PartnerMixin, DateTimeConverterMixin, SvgMixin],
  props: {
    activations: {
      type: Array,
      default: () => []
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      updatedActivations: this.activations,
      activationToPublish: null,
    }
  },
  computed: {
    ...mapGetters(['user']),
    contentHeight() {
      const btnHeight = 40
      const itemHeight = 51
      const itemGap = 8

      return btnHeight + (this.activations.length * (itemHeight + itemGap));
    }
  },
  watch: {
    activations(newVal, oldVal) {
      if (newVal[0]?._id != oldVal[0]?._id) {
        this.updatedActivations = newVal;
      }
    }
  },
  methods: {
    editActivation(activation) {
      this.$emit('edit', activation.id);
    },
    viewActivation(activation) {
      this.$emit('view', activation.id);
    },
    async bookmarkActivation(activation) {
      await this.$store.dispatch('bookmarkCompanyOffer', { entityId: activation.id, entityType: 'offer' })

      if (this.user.bookmarked_offers.includes(activation.id))
        this.setAlert(`Successfully bookmarked the collection!`);
      else
        this.setAlert(`Successfully removed the bookmarked collection!`);
    },
    handleClickActivation(activation) {
      if (['Published', 'PublishedDraft'].includes(activation.document_state))
        this.viewActivation(activation);
      else
        this.editActivation(activation);
    },
    publishActivation(activation) {
      this.activationToPublish = activation;
    },
    async unPublish(activation) {
      await this.unPublishOffer(activation.id);

      if (activation.pvActivationId)
        await this.unPublishActivation(activation.id);

      this.setAsUnPublished(activation);
    },
    deleteActivation(activation) {
      this.setAlert("Delete is not implemented yet");
    },
    getListItems(activation) {

      let bookmarkIcon = 'bookmarked';
      if (this.user.bookmarked_offers.map(bookmarks => bookmarks._id).includes(activation.id))
        bookmarkIcon = 'bookmarkedFilled';

      let publishListItem = { label: 'Publish', svgIcon: this.bookmarkIcon, action: this.publishActivation }
      if (activation.document_state === 'Published')
        publishListItem = { label: 'Unpublish', svgIcon: this.bookmarkIcon, action: this.unPublish }

      return [
        { label: 'Edit', icon: 'pencil', action: this.editActivation},
        { label: 'Bookmark', icon: bookmarkIcon, action: this.bookmarkActivation },
        publishListItem,
        { label: 'Delete', icon: 'trashcan', action: this.deleteActivation },
      ];
    },
    setAsUnPublished(activation) {
      activation.document_state = 'Draft';
      activation.public = false;
    },
    setAsPublished(activationId, activationDate) {
      let publishedActivation = this.updatedActivations.find(activation => activation.id === activationId);
      if (this.isToday(activationDate)) {
        publishedActivation.document_state = 'Published';
        publishedActivation.public = true;
      } else
        publishedActivation.document_state = 'Scheduled';
        publishedActivation.scheduled_publish_at = activationDate;

      this.activationToPublish = null;
    },
  },
}
</script>

<style lang="scss" scoped>
@import './CampaignCard.scss';
.empty {
  > p {
    padding: 0 0 0 16px;
  }
}

.activations {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  max-height: 1280px; // A value larger than your content's height.
  opacity: 1;
  overflow: hidden;   // This is crucial, to hide the content that overflows due to max-height.
  transition: opacity 0.3s, max-height 0.3s;  // Add a delay to opacity transition when expanding.

  > * {
    margin-top: 8px;
  }


  .item {
    padding: 0 0 0 16px;
  }

  .activation {
    cursor: pointer;
  }
}

.fade-shrink-enter-active,
.fade-shrink-leave-active {
  transition: opacity 0.3s, max-height 0.3s;
}

.fade-shrink-enter,
.fade-shrink-leave-to /* or .fade-shrink-leave-active in <2.1.8 */ {
  max-height: 0;
  opacity: 0;
}
</style>
